import React from 'react';

import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';

// eslint-disable-next-line max-len
import ManageAffordableWaitlistModals from '../../../containers/ManageAffordableWaitlist/ManageAffordableWaitlistModals';
// eslint-disable-next-line max-len
import WaitlistV2StatusActionModals from '../../../containers/ApplicationProfile/LeaseApplicationTab/WaitlistV2StatusActionModals';

import useApplicationStatus from './hooks';
import useIntl from '../../../hooks/useIntl';

export default function ApplicationStatus({
  application,
  applicationStatusChangeHandler,
  applicationStatuses,
  handleStatusChange,
  waitlistModalProps,
  applicationStatusUpdateAllowed,
  leaseExecuted,
  leaseSentToPortal,
  isResident,
  headOfHouseholdId,
  affordableWaitlistRecord,
  applicationStatusId,
  localWaitlistInfo,
  waitlistActions,
  organizationId,
  propertyId,
  floorPlans,
  refreshApplication,
}) {
  const intl = useIntl();
  const {
    ReactHookFormProps,
    formProps,
    showAddToWaitlistModal,
    isV2WaitlistEnabled,
    pendingWaitlistV2Action,
    handleWaitlistV2ActionClose,
    handleWaitlistV2ActionSuccess,
  } = useApplicationStatus({
    application,
    applicationStatusChangeHandler,
    applicationStatuses,
    handleStatusChange,
    waitlistModalProps,
    applicationStatusUpdateAllowed,
    leaseExecuted,
    leaseSentToPortal,
    isResident,
    headOfHouseholdId,
    affordableWaitlistRecord,
    applicationStatusId,
    localWaitlistInfo,
    waitlistActions,
    refreshApplication,
  });

  return (
    <Box
      sx={{
        px: 6,
        width: '100%',
      }}
    >
      <Form ReactHookFormProps={ReactHookFormProps} {...formProps} />
      {showAddToWaitlistModal && (
        <ManageAffordableWaitlistModals
          applicationStatusId={applicationStatusId}
          organizationId={organizationId}
          propertyId={propertyId}
          applicationId={application?.id}
          intl={intl}
          {...waitlistModalProps}
        />
      )}
      {isV2WaitlistEnabled && (
        <WaitlistV2StatusActionModals
          organizationId={organizationId}
          propertyId={propertyId}
          affordableWaitlistId={affordableWaitlistRecord?.id ?? null}
          applicationId={application?.id}
          floorPlans={floorPlans}
          pendingAction={pendingWaitlistV2Action}
          onClose={handleWaitlistV2ActionClose}
          onSuccess={handleWaitlistV2ActionSuccess}
        />
      )}
    </Box>
  );
}
